<template>
  <div class="section">
    <div class="section-head">
      <img src="~@/assets/img/itles-webapp-videoClass/title-ld.png" alt />
    </div>
    <div class="section-conect">
      <ul>
        <li v-for="(item, index) in list" :key="index" class="item">
          <div class="item-head">
            <span class="item-number">{{ index | filterNum }}</span>
            <span class="item-title">{{ item.title }}</span>
          </div>
          <p class="item-des">{{ item.desc }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["list"],
  data() {
    return {};
  },
  filters: {
    filterNum: num => {
      let _num = num + 1;
      return _num < 10 ? `0${_num}` : _num;
    }
  }
};
</script>
<style lang="scss" scoped>
.section-head {
  img {
    display: block;
    width: tovw(368);
    height: tovw(48);
    margin: tovw(40) auto;
    margin-top: tovw(80);
  }
}
.section-conect {
  .item-head {
    height: tovw(64);
    line-height: tovw(64);
    background: url(~@/assets/img/itles-webapp-videoClass/icon-label-ld.png)
      no-repeat;
    background-size: tovw(144) 100%;
    .item-number {
      float: left;
      font-size: tovw(40);
      padding-left: tovw(24);
      padding-top: tovw(2);
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: rgba(251, 188, 0, 1);
    }
    .item-title {
      display: inline-block;
      width: tovw(560);
      font-size: tovw(34);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      padding-left: tovw(20);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .item-des {
    margin-top: tovw(20);
    margin-bottom: tovw(30);
    padding-left: tovw(8);
    font-size: tovw(32);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.8);
    line-height: tovw(48);
  }
}
</style>
